import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'react-bootstrap';

const Alerts = ({ 
    error, 
    success, 
    fadingAlerts, 
    onCloseError, 
    onCloseSuccess, 
    onCloseDetailsSearchError 
}) => {
    return (
        <>
            {error.display && (
                <Alert
                    variant="danger"
                    dismissible
                    className={`status-alert ${fadingAlerts.displayError ? 'fade-out' : ''}`}
                    onClose={onCloseError}
                >
                    {error.message}
                </Alert>
            )}
            {success.statusUpdate && (
                <Alert
                    variant="success"
                    dismissible
                    className={`status-alert ${fadingAlerts.statusUpdateSuccess ? 'fade-out' : ''}`}
                    onClose={onCloseSuccess}
                >
                    {success.message}
                </Alert>
            )}
            {error.displayDetailsSearch && (
                <Alert
                    variant="danger"
                    dismissible
                    className={`status-alert ${fadingAlerts.displayDetailsSearchError ? 'fade-out' : ''}`}
                    onClose={onCloseDetailsSearchError}
                >
                    {error.detailsSearch}
                </Alert>
            )}
        </>
    );
};

Alerts.propTypes = {
    error: PropTypes.shape({
        display: PropTypes.bool,
        message: PropTypes.string,
        displayDetailsSearch: PropTypes.bool,
        detailsSearch: PropTypes.string
    }).isRequired,
    success: PropTypes.shape({
        statusUpdate: PropTypes.bool,
        message: PropTypes.string
    }).isRequired,
    fadingAlerts: PropTypes.shape({
        displayError: PropTypes.bool,
        statusUpdateSuccess: PropTypes.bool,
        displayDetailsSearchError: PropTypes.bool
    }).isRequired,
    onCloseError: PropTypes.func.isRequired,
    onCloseSuccess: PropTypes.func.isRequired,
    onCloseDetailsSearchError: PropTypes.func.isRequired
};

export default Alerts; 